import { configValue } from '#/config/appConfigUtils';

import type { UploadHookParams, UploadHookResult } from './types';
import { useFilestackUpload } from './useFilestackUpload';
import { useMockUpload } from './useMockUpload';

// NOTE: We need to delay the `configValue` call until the hook is
// called because our config is not parsed during module execution.
// `configValue` doesn't change during runtime, so we can use a ternary
// inside the hook.
export const useUpload = (params: UploadHookParams): UploadHookResult =>
  configValue('filestack', 'mock')
    ? // oxlint-disable-next-line react-hooks/rules-of-hooks
      useMockUpload(params)
    : // oxlint-disable-next-line react-hooks/rules-of-hooks
      useFilestackUpload(params);
